import React from "react";
//pages
import Home from "./pages/Home";
import Experience from "./pages/Experience";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";
import Footer from "./pages/Footer";
//components
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import Chat from "./components/Chat";
import ChatEntrancer from "./components/ChatEntrancer";
import { useGlobalContext } from "./useContext";
import Lenis from "lenis";
import styled from "styled-components";



const App = () => {
const {isChat}=useGlobalContext();
const [showEn, setShowEn] = React.useState(false);


  React.useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowEn(true);
    }, 6000);

    return () => clearTimeout(timeoutId);
  }, []);

  //for scroll with lenis
  React.useEffect(()=> {
    const lenis = new Lenis({
      duration: 1.2, 
      easing: (t) => t * (2 - t),
      smoothWheel: true, 
      smoothTouch: false
    });

    // Rularea animației de scroll
    function animate(time) {
      lenis.raf(time);
      requestAnimationFrame(animate);
    }

    requestAnimationFrame(animate);

    // Cleanup pentru a preveni memory leaks
    return () => {
      lenis.destroy();
    };
  }, []);

  return (
      <AppWrapper className="app-container section__center">
        <Navbar />
        <Sidebar></Sidebar>
        <Chat setShowEn={setShowEn}></Chat>
        {!isChat && showEn && (
          <ChatEntrancer setShowEn={setShowEn}></ChatEntrancer>
        )}
        <div className="container">
          <Home />
          <Experience />
          <Projects />
          <Contact />
          <Footer></Footer>
        </div>
      </AppWrapper>
  );
};

const AppWrapper = styled.div`
  /* Custom Scrollbar for Chrome, Safari, Edge */
  ::-webkit-scrollbar {
    width: 12px;
  }

  ::-webkit-scrollbar-track {
    background: white;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
    border: 2px solid white;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  ::-webkit-scrollbar-corner {
    background: white;
  }

  /* Firefox */
  * {
    scrollbar-width: thin;
    scrollbar-color: #888 white;
  }

  html {
    scrollbar-width: thin;
    scrollbar-color: #888 white;
  }
`;

export default App;
